var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[239],"data-type":_vm.dataType,"field-code":"public-transportation","graph-id":60,"title":_vm.title,"unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }